// CoordinateConverter.js
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { Point } from 'ol/geom';
import { Feature } from 'ol';
import { Style, Circle, Fill, Stroke, Text } from 'ol/style';
import { map } from './Map';
import { CoordinateService } from './CoordinateService'; // استيراد الخدمة المركزية

const source = new VectorSource();
const vectorLayer = new VectorLayer({
    source: source,
    name: 'ConvertedCoordinates',
    // استخدام Style Function لرفع الأداء بدل تعيين الستايل لكل نقطة يدوياً
    style: function(feature) {
        const coords = feature.getGeometry().getCoordinates();
        const palX = coords[0].toFixed(0);
        const palY = coords[1].toFixed(0);
        return new Style({
            image: new Circle({
                radius: 7,
                fill: new Fill({ color: '#dc3545' }),
                stroke: new Stroke({ color: '#ffffff', width: 2 })
            }),
            text: new Text({
                text: `X: ${palX}, Y: ${palY}`,
                font: '12px Calibri,sans-serif',
                fill: new Fill({ color: '#000' }),
                stroke: new Stroke({ color: '#fff', width: 3 }),
                offsetY: -15
            })
        });
    }
});

map.addLayer(vectorLayer);

let isConverterActive = false;
let lastClickTime = 0; // للتحكم بسرعة النقر (Throttle)

$('#coordinateConverter').click(function () {
    const button = $(this);
    if (!isConverterActive) {
        startCoordinateConversion(button);
    } else {
        stopCoordinateConversion(button);
    }
});

function startCoordinateConversion(button) {
    isConverterActive = true;
    button.addClass('active');
    button.find('span').text('إيقاف تحويل الإحداثيات');
    button.find('i').removeClass('fa-exchange-alt').addClass('fa-times');

    showCoordinatePanel();
    addMapClickListener();
}

function stopCoordinateConversion(button) {
    isConverterActive = false;
    button.removeClass('active');
    button.find('span').text('تحويل الإحداثيات');
    button.find('i').removeClass('fa-times').addClass('fa-exchange-alt');

    hideCoordinatePanel();
    removeMapClickListener();
    source.clear(); 
}

function showCoordinatePanel() {
    const draggable = $('#draggable');
    const title = $('#draggable-title');
    const content = $('#draggable-content');

    title.html('تحويل الإحداثيات');
    content.html(`
        <div style="text-align: right; direction: rtl;">
            <div style="margin-bottom: 15px;">
                <h6 style="color: #dc3545; margin-bottom: 10px;">
                    <i class="fas fa-crosshairs"></i> انقر على الخريطة لتحديد نقطة
                </h6>
                <div id="coordinateDisplay" style="font-size: 0.9rem; color: #333; line-height: 1.6;">
                    <p><strong>الإحداثيات المحلية:</strong></p>
                    <p>X: <span id="palX">--</span>, Y: <span id="palY">--</span></p>
                    <p><strong>الإحداثيات العالمية (WGS 1984):</strong></p>
                    <p>خط العرض: <span id="wgsLat">--</span>, خط الطول: <span id="wgsLon">--</span></p>
                </div>
            </div>
            <div style="margin-bottom: 15px;">
                <button id="copyCoords" style="background: #dc3545; color: white; border: none; padding: 8px 15px; border-radius: 4px; cursor: pointer; width: 100%;">
                    <i class="fas fa-copy"></i> نسخ الإحداثيات
                </button>
            </div>
            <div style="margin-bottom: 15px;">
                <button id="clearCoords" style="background: #6c757d; color: white; border: none; padding: 8px 15px; border-radius: 4px; cursor: pointer; width: 100%;">
                    <i class="fas fa-trash"></i> مسح النقاط
                </button>
            </div>
            <div id="savedPoints" style="max-height: 200px; overflow-y: auto; border-top: 1px solid #eee; padding-top: 10px;">
                <h6 style="color: #dc3545; margin-bottom: 10px;">النقاط المحفوظة:</h6>
                <p style="font-size: 0.85rem; color: #666; text-align: center;">لا توجد نقاط محفوظة بعد.</p>
            </div>
        </div>
    `);
    draggable.show();

    $('#copyCoords').click(copyCoordinatesToClipboard);
    $('#clearCoords').click(clearAllPoints);
}

function hideCoordinatePanel() {
    $('#draggable').hide();
}

function addMapClickListener() {
    // استخدام singleclick وهو الأفضل للأجهزة المحمولة
    map.on('singleclick', handleMapClick);
}

function removeMapClickListener() {
    map.un('singleclick', handleMapClick);
}

function handleMapClick(evt) {
    if (!isConverterActive) return;

    // حماية من النقر المزدوج السريع (Throttle 300ms)
    const currentTime = new Date().getTime();
    if (currentTime - lastClickTime < 300) return;
    lastClickTime = currentTime;

    // البحث عن النقطة باستخدام forEachFeatureAtPixel (سريع وموثوق على الموبايل)
    const feature = map.forEachFeatureAtPixel(evt.pixel, function (feat, layer) {
        return feat;
    }, {
        layerFilter: function (layer) {
            return layer === vectorLayer;
        }
    });

    if (feature) {
        const coords = feature.getGeometry().getCoordinates();
        displayCoordinates(coords);
    } else {
        // الحد من عدد النقاط للحفاظ على الأداء (مثلاً 50 نقطة كحد أقصى)
        if (source.getFeatures().length >= 50) {
            source.clear();
        }
        const coords = evt.coordinate;
        addPointToMap(coords);
        displayCoordinates(coords);
    }
}

function addPointToMap(coords) {
    const feature = new Feature({
        geometry: new Point(coords)
    });
    source.addFeature(feature);
    updateSavedPoints();
}

function displayCoordinates(coords) {
    const mapProjCode = map.getView().getProjection().getCode();
    const wgs84Coords = CoordinateService.toWGS84(coords, mapProjCode);

    $('#palX').text(coords[0].toFixed(2));
    $('#palY').text(coords[1].toFixed(2));
    
    if (wgs84Coords) {
        $('#wgsLat').text(wgs84Coords[1].toFixed(6));
        $('#wgsLon').text(wgs84Coords[0].toFixed(6));
    } else {
        $('#wgsLat').text('--');
        $('#wgsLon').text('--');
    }
}

function copyCoordinatesToClipboard() {
    const palX = $('#palX').text();
    const palY = $('#palY').text();
    const wgsLat = $('#wgsLat').text();
    const wgsLon = $('#wgsLon').text();

    if (palX === '--' || wgsLat === '--') {
        alert("لا توجد إحداثيات لنسخها. يرجى تحديد نقطة على الخريطة أولاً.");
        return;
    }

    const mapProjCode = map.getView().getProjection().getCode();
    const textToCopy = `الإحداثيات المحلية (${mapProjCode}): X=${palX}, Y=${palY}\nالإحداثيات العالمية (WGS 1984): Lat=${wgsLat}, Lon=${wgsLon}`;

    if (navigator.clipboard) {
        navigator.clipboard.writeText(textToCopy).then(() => {
            const button = $('#copyCoords');
            const originalText = button.html();
            button.html('<i class="fas fa-check"></i> تم النسخ');
            button.css('background', '#28a745');
            setTimeout(() => {
                button.html(originalText);
                button.css('background', '#dc3545');
            }, 2000);
        }).catch(err => {
            console.error('Failed to copy: ', err);
            fallbackCopyTextToClipboard(textToCopy);
        });
    } else {
        fallbackCopyTextToClipboard(textToCopy);
    }
}

function fallbackCopyTextToClipboard(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
        document.execCommand('copy');
        alert('تم نسخ الإحداثيات بنجاح');
    } catch (err) {
        alert('فشل في نسخ الإحداثيات');
    }
    document.body.removeChild(textArea);
}

function updateSavedPoints() {
    const savedPointsDiv = $('#savedPoints');
    const features = source.getFeatures();

    if (features.length === 0) {
        savedPointsDiv.html(`
            <h6 style="color: #dc3545; margin-bottom: 10px;">النقاط المحفوظة:</h6>
            <p style="font-size: 0.85rem; color: #666; text-align: center;">لا توجد نقاط محفوظة بعد.</p>
        `);
        return;
    }

    let html = `<h6 style="color: #dc3545; margin-bottom: 10px;">النقاط المحفوظة:</h6>`;
    const mapProjCode = map.getView().getProjection().getCode();

    features.forEach((feature, index) => {
        const coords = feature.getGeometry().getCoordinates();
        const palX = coords[0].toFixed(2);
        const palY = coords[1].toFixed(2);
        
        const wgs84Coords = CoordinateService.toWGS84(coords, mapProjCode);
        const wgsLat = wgs84Coords ? wgs84Coords[1].toFixed(6) : '--';
        const wgsLon = wgs84Coords ? wgs84Coords[0].toFixed(6) : '--';

        html += `
            <div class="saved-point-item" style="border: 1px solid #ddd; border-radius: 6px; padding: 8px; margin-bottom: 8px; background: #f8f9fa;">
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 5px;">
                    <strong style="color: #dc3545;">نقطة ${index + 1}</strong>
                    <button class="remove-point-btn" data-index="${index}" style="background: #dc3545; color: white; border: none; padding: 2px 6px; border-radius: 3px; cursor: pointer; font-size: 0.7rem;">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
                <div style="font-size: 0.85rem; color: #333;">
                    <p style="margin: 0;"><strong>محلية:</strong> X: ${palX}, Y: ${palY}</p>
                    <p style="margin: 0;"><strong>عالمية:</strong> Lat: ${wgsLat}, Lon: ${wgsLon}</p>
                </div>
            </div>
        `;
    });
    savedPointsDiv.html(html);

    // ربط حدث الحذف بدون استخدام المتغيرات العامة (Global Variables)
    $('.remove-point-btn').off('click').on('click', function() {
        const idx = $(this).data('index');
        const feats = source.getFeatures();
        if (idx >= 0 && idx < feats.length) {
            source.removeFeature(feats[idx]);
            updateSavedPoints();
        }
    });
}

function clearAllPoints() {
    source.clear();
    updateSavedPoints();
    $('#palX').text('--');
    $('#palY').text('--');
    $('#wgsLat').text('--');
    $('#wgsLon').text('--');
}

$('#draggable-closer').click(function () {
    if ($('#draggable-title').text() === 'تحويل الإحداثيات') {
        stopCoordinateConversion($('#coordinateConverter'));
    }
});

export { vectorLayer };

